module.exports = __webpack_public_path__ + "img/go-with-freedom.4d7d3130.png";